import {faBars} from "@fortawesome/free-solid-svg-icons";

import React from 'react';

import {Image} from "@florian-cassagne/simple-toolbox";

function NavDisplayButton({isDisplayed, setDisplayed}) {

  let imgMenuBars = '/img/misc/icons/menu-bars.png';
  let imgClose = '/img/misc/icons/close.png';

  return (
    <div className={'nav__display-button p-2 w-12'}
          onClick={() => setDisplayed(!isDisplayed)}>
        <Image className={'transition-all duration-500  !py-0 ' +
          (isDisplayed ? '!w-0 ' : 'w-full')}
               src={imgMenuBars}
               isFancyMode={false}
        />
        <Image className={'transition-all duration-500  !py-0 ' +
          (!isDisplayed ? '!w-0 ' : 'w-full')}
               src={imgClose}
               isFancyMode={false}
        />

    </div>
  );
}


export default NavDisplayButton;
